export const defaultSearchOrder = {
  order_by: 'ts',
  order_value: -1,
};
